import React from "react";
import { AuthContext } from "../../lib/AuthContext";
import ParentComponent from "../../lib/ParentComponent";
import firebase, { auth } from "../../lib/firebase";
import Utils from "../../Utils";
import { deleteUrl, exportUrl, notiUrl } from "../../constants";
import ar from "../../locale";

export default class Users extends ParentComponent {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    this.state = {
      user: context.user,
      users: [],
      admins: {},
      loading: true,
      token: null,
      sending: false,
      deleting: {},
    };
    this.usersRef = firebase.database().ref("users/");
    this.adminRef = firebase.database().ref("admin_users/");
  }

  componentDidMount() {
    super.componentDidMount();
    auth.currentUser.getIdToken().then((token) => {
      this.state.token = token;
      this.updateState();
    });
    this.usersRef.on("value", (snapshot) => {
      this.state.users = Utils.convertToArrayWithInsertionOrder(snapshot.val());
      this.state.loading = false;
      this.updateState();
    });
    this.adminRef.on("value", (snapshot) => {
      this.state.admins = snapshot.val();
      this.updateState();
    });
    window.Tablesaw.init(this.$("#sawtable"));
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    this.usersRef.off("value");
    this.adminRef.off("value");
  }

  showLoading = (show) => {
    this.state.loading = show;
    this.updateState();
  };

  updateState = () => {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {
      this.setState((prev) => {
        return { ...prev };
      });
    }, 10);
  };

  makeAdmin = (user, e) => {
    let isAdmin = e.target.checked;
    let refP;
    if (isAdmin) {
      refP = this.adminRef.child(user.uid).set({
        name: user.name,
      });
    } else {
      refP = this.adminRef.child(user.uid).remove();
    }

    refP
      .then(() => this.updateAdminAttributeInUser(user, isAdmin ? true : null))
      .then((res) => {
        this.showSuccess(ar.operation_successful);
      })
      .catch((error) => {
        this.showError(error.message);
      });
  };

  /**
   * This will be just for show purpose
   */
  updateAdminAttributeInUser = (user, isAdmin) => {
    return this.usersRef.child(user.uid).update({
      admin: isAdmin,
    });
  };

  renderUsers = (user) => {
    let isAdmin = this.state.admins[user.uid] ? true : false;
    return (
      <tr key={user.uid}>
        <td className="title">
          {user.photoURL && (
            <img
              src={user.photoURL}
              alt="avatar"
              className="avatarc rounded-circle"
              width="30"
              height="30"
            />
          )}
          {!user.photoURL && (
            <img
              src="/assets/images/blankuser.png"
              alt="avatar"
              className="avatarc rounded-circle"
              width="30"
              height="30"
            />
          )}
        </td>
        <td>
          <p className="mb-0">{user.name}</p>
          <p className="mb-0">
            {ar.gender} - {user.gender}
          </p>
          <p className="mb-0">
            {ar.birthdate} - {user.dob}
          </p>
        </td>
        <td>
          <p className="mb-0">{user.email}</p>
          <p className="mb-0 ltr">{user.contact}</p>
        </td>
        <td className="ltr">{user.club_name}</td>
        <td>
          <input
            type="checkbox"
            onChange={this.makeAdmin.bind(this, user)}
            defaultChecked={isAdmin}
            className="cursor-pointer"
          />
        </td>
        <td>
          {!this.state.deleting[user.uid] && (
            <i
              className="fa fa-trash text-danger cursor-pointer"
              title={ar.delete}
              onClick={this.deleteUserConfimation.bind(this, user)}
            ></i>
          )}
          {this.state.deleting[user.uid] && (
            <span
              className="d-inline-block spinner-border spinner-border-sm text-danger"
              role="status"
            ></span>
          )}
        </td>
      </tr>
    );
  };

  deleteUserConfimation = (user) => {
    this.confirm(null, this.deleteUserProcess.bind(this, user));
  };

  deleteUserProcess = (user) => {
    this.state.deleting[user.uid] = true;
    this.updateState();
    fetch(deleteUrl, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.token,
      },
      body: JSON.stringify({
        path: "users/" + user.uid,
        users: "true",
        uid: user.uid,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        this.updateState();
      })
      .catch((error) => {
        this.state.deleting[user.uid] = false;
        this.showError(error.message);
      });
  };

  sendNotification = () => {
    let text = this.text.value;
    if (text) {
      this.state.sending = true;
      this.updateState();
      fetch(notiUrl, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.token,
        },
        body: JSON.stringify({
          topics: "__notiupdates",
          uid: this.state.user.uid,
          message: text,
        }),
      })
        .then((response) => {
          this.text.value = "";
          this.state.sending = false;
          this.updateState();
          this.showSuccess(ar.operation_successful);
        })
        .catch((error) => {
          this.showError(error.message);
          this.state.sending = false;
          this.updateState();
        });
    } else {
      this.showError(ar.please_fill_all_options);
    }
  };

  render() {
    let { loading, sending } = this.state;
    return (
      <div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card no-toolbar mb-0 border-0">
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-4 mt-2">
                      <h2 className="card-title">{ar.user}</h2>
                      <h5 className="card-subtitle mb-0">
                        {ar.total} - {this.state.users.length}
                      </h5>
                      <div className="mt-3">
                        <form action={exportUrl} target="_blank" method="post">
                          <input
                            type="hidden"
                            name="path"
                            value="users"
                            formEncType="application/x-www-form-urlencoded"
                          />
                          <input
                            type="hidden"
                            name="token"
                            defaultValue={this.state.token}
                          />
                          <input type="hidden" name="fields" value="uid" />
                          <input type="hidden" name="fields" value="name" />
                          <input type="hidden" name="fields" value="email" />
                          <input type="hidden" name="fields" value="contact" />
                          <input type="hidden" name="fields" value="gender" />
                          <input type="hidden" name="fields" value="dob" />
                          <input
                            type="hidden"
                            name="fields"
                            value="club_name"
                          />
                          <input type="hidden" name="fields" value="admin" />
                          <button
                            type="submit"
                            className="btn btn-info btn-rounded min-w100"
                          >
                            {ar.download}
                          </button>
                        </form>
                      </div>
                    </div>
                    <div className="col-sm-8 mt-2">
                      <div className="form-group">
                        <label
                          htmlFor="inputname"
                          className="control-label col-form-label"
                        >
                          <span className="text-danger ml-1">*</span>
                          {ar.send_notification_users}
                        </label>
                        <input
                          type="text"
                          ref={(e) => (this.text = e)}
                          className="form-control"
                          id="inputname"
                          maxLength="60"
                        />
                      </div>
                      <div className="button-group mt-3">
                        {sending && (
                          <button
                            type="button"
                            className="btn waves-effect waves-light btn-rounded btn-info"
                          >
                            <span
                              className="spinner-border spinner-border-sm text-white"
                              role="status"
                            ></span>
                          </button>
                        )}
                        {!sending && (
                          <button
                            type="button"
                            className="btn waves-effect waves-light btn-rounded btn-info"
                            onClick={this.sendNotification}
                          >
                            {ar.send}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="card no-toolbar">
                <div className="card-body">
                  <table
                    id="sawtable"
                    className="tablesaw table-bordered table-striped table-hover table no-wrap"
                    data-tablesaw-mode="swipe"
                  >
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          data-tablesaw-priority="1"
                          className="border"
                        >
                          &nbsp;
                        </th>
                        <th
                          scope="col"
                          data-tablesaw-sortable-col
                          data-tablesaw-priority="3"
                          className="border"
                        >
                          {ar.name}
                        </th>
                        <th
                          scope="col"
                          data-tablesaw-sortable-col
                          data-tablesaw-priority="2"
                          className="border"
                        >
                          {ar.email}
                        </th>
                        <th
                          scope="col"
                          data-tablesaw-priority="1"
                          className="border"
                        >
                          {ar.club}
                        </th>
                        <th
                          scope="col"
                          data-tablesaw-priority="0"
                          className="border"
                        >
                          {ar.admin}
                        </th>
                        <th
                          scope="col"
                          data-tablesaw-priority="1"
                          className="border"
                        >
                          {ar.delete}
                        </th>
                      </tr>
                    </thead>
                    {!loading && this.state.users.length > 0 && (
                      <tbody>
                        {this.state.users.map((user, index) =>
                          this.renderUsers(user)
                        )}
                      </tbody>
                    )}
                  </table>
                  {!loading && this.state.users.length === 0 && (
                    <div className="p-5 d-flex justify-content-center text-center">
                      <span className="">{ar.section_empty}</span>
                    </div>
                  )}
                  {loading && (
                    <div className="p-5 d-flex justify-content-center text-center">
                      <span
                        className="spinner-border spinner-border-sm text-info"
                        role="status"
                      ></span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
